const escapar = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/**
 * Marcado de los resúmenes GPC del legacy a HTML seguro: `**negrita**`, `__cursiva__` y saltos de
 * línea. Se escapa todo antes, así que el texto nunca inyecta HTML.
 */
export function marcadoAHtml(texto: string): string {
  return escapar(texto)
    .replace(/\*\*([\s\S]+?)\*\*/g, '<strong>$1</strong>')
    .replace(/__([\s\S]+?)__/g, '<em>$1</em>')
    .replace(/\r?\n/g, '<br>');
}

/** Envuelve la selección de un textarea con el marcador (o lo inserta vacío en el cursor). */
export function envolver(
  valor: string,
  inicio: number,
  fin: number,
  marca: string,
): { valor: string; cursor: number } {
  const sel = valor.slice(inicio, fin);
  return {
    valor: valor.slice(0, inicio) + marca + sel + marca + valor.slice(fin),
    cursor: fin + marca.length * (sel ? 2 : 1),
  };
}
